// importing images

import izzyProfilePic from "../images/IzzyProfilePic.png";
import lianaProfilePic from "../images/lianaProfilePic.png";
import cameronProfilePic from "../images/cameronProfilePic.jpeg";
import emilioProfilePic from "../images/emilioProfilePic.jpeg";
import stinaProfilePic from "../images/christinaProfilePic.png";
import pushkarProfilePic from "../images/pushkarProfilePic.jpeg";

export const reviews = [
  {
    name: "Izzy Sunday",
    title: "YouTuber",
    review:
      "The community has been the best way to connect with content creators all over the world. I've continued to grow so much.",
    imageSource : izzyProfilePic,
  },
  {
    name: "Liana",
    title: "Content Creator",
    review:
      "I'm so glad I joined this community, being able to connect with other content creators has helped fuel my passion to create!",
    imageSource: lianaProfilePic,
  },
  {
    name: "Cameron",
    title: "Fitness YouTuber",
    review:
      "The community has given me just that bit of extra motivation to keep going with creating content.",
    imageSource: cameronProfilePic,
  }
];

export const communityReview = [
  {
    name: "Emilio",
    title: "Indie Game Developer, Creator",
    review:
      "Being an introvert, I was nervous to join but this is one of the best decisions I’ve ever made.",
    imageSource: emilioProfilePic,
  },
  {
    name: "Stina",
    title: "Content Creator",
    review:
      "This is a great global community of creators coming together to create something even greater.",
    imageSource: stinaProfilePic,
  },
  {
    name: "Pushkar",
    title: "Web Developer, YouTuber",
    review:
      "Every call puts a big smile on my face and gives me the community I have always needed.",
    imageSource: pushkarProfilePic,
  }
];
